var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'sidebar': _vm.sidebar},style:(_vm.wrapper_style),attrs:{"id":"wrapper-avatar","data-type":_vm.type}},[_c('div',{attrs:{"id":"avatar"}},[_c('div',{style:(_vm.style),attrs:{"id":"avatar-inner","data-gender":_vm.gender,"data-nickname":_vm.short_nickname}},[_c('ImageFadeIn',{attrs:{"src":_vm.avatar_src}})],1)]),_c('ImageFadeIn',{style:({
      bottom: (_vm.flair_size > 20 ? '-15px' : '-10%'),
      left: (_vm.flair_size > 20 ? '-15px' : '-10%'),
    }),attrs:{"src":_vm.flair_src,"height":_vm.flair_size,"width":_vm.flair_size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }